import api from "./axios";

export const clientApi = {
  list: () => api.get("/clients").then((r) => r.data),
  get: (id: string) => api.get(`/clients/${id}`).then((r) => r.data),
  create: (data: {
    name: string;
    description?: string;
    country: string;
    currency: string;
  }) => api.post("/clients", data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    api.patch(`/clients/${id}`, data).then((r) => r.data),
  remove: (id: string) => api.delete(`/clients/${id}`),
  linkProject: (id: string, projectId: string) =>
    api.post(`/clients/${id}/projects/${projectId}`).then((r) => r.data),
  unlinkProject: (id: string, projectId: string) =>
    api.delete(`/clients/${id}/projects/${projectId}`),
  linkTeam: (id: string, teamId: string) =>
    api.post(`/clients/${id}/teams/${teamId}`).then((r) => r.data),
  unlinkTeam: (id: string, teamId: string) =>
    api.delete(`/clients/${id}/teams/${teamId}`),
};
